import React from "react";
import { logout } from "@smfa/utils/src";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    log.error("React Error Boundary caught error:", error, errorInfo);

    // Check if it's an auth-related error
    if (
      error.message?.includes("Unauthorized") ||
      error.message?.includes("401") ||
      error.toString().includes("Authentication")
    ) {
      log.warn("Auth-related error detected - forcing logout");
      logout();
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div
          style={{
            padding: "20px",
            margin: "20px",
            border: "1px solid #f00",
            borderRadius: "4px",
          }}
        >
          <h2>Something went wrong</h2>
          <p>
            The application encountered an error. Please try refreshing the
            page.
          </p>
          <button onClick={() => window.location.reload()}>Refresh Page</button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
